import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { Link, useHistory } from "react-router-dom"
import TableContainer from "../../components/Common/TableContainer"
import {
  getUserDetails,
  setGlobalLoading,
} from "../../store/slices"

import {
  FormattedTime,
  Total,
  //   PaymentMethod,
} from "../Pets/components/PatientsCol"

//redux
import { useSelector, useDispatch } from "react-redux"

import { Col, Row, UncontrolledTooltip, Card, CardBody } from "reactstrap"
import { getImagingAndLap } from "helpers/api_helper"
import { IconSVG } from "components/Common/IconSvg"
import Lightbox from "react-image-lightbox"
import LeftArrow from "../../assets/icons/ArrowLeft.png"

function ImagingRequestList() {
  //meta title
  document.title = "Imaging Request | SuPaw"

  const userDetails = useSelector(getUserDetails)
  const [list, setList] = useState([])
  const [photoIndex, setphotoIndex] = useState(0)
  const [isGalleryZoom, setisGalleryZoom] = useState(false)
  const [currentScans, setCurrentScans] = useState([])
  const history = useHistory()

  const dispatch = useDispatch()

  useEffect(() => {
    const fetchData = async () => {
      dispatch(setGlobalLoading(true))
      const list = await getImagingAndLap({
        doctorId: userDetails._id,
        testType: "imaging",
      })
      setList(list.data.filter(ell => ell.status === "Completed"))
      dispatch(setGlobalLoading(false))
    }
    fetchData()
  }, [dispatch])

  const handleAddNewRequest = () => {
    history.push("/add-imaging-request")
  }
  const Cost = cell => {
    if (typeof cell.value === "number") {
      return "Rs " + Number(cell.value)
    }
    return ""
  }

  const columns = useMemo(
    () => [
      {
        Header: "Date Requested ",
        accessor: "createdAt",
        filterable: true,
        Cell: cellProps => {
          return <FormattedTime {...cellProps} />
        },
      },
      // {
      //   Header: "Requested By",
      //   accessor: "email",
      //   filterable: true,
      //   Cell: cellProps => {
      //     return <Date {...cellProps} />
      //   },
      // },
      {
        Header: "Patient",
        accessor: "petObjectId.fullName",
        filterable: true,
        Cell: cellProps => {
          return <Total {...cellProps} />
        },
      },
      {
        Header: "Imaging Type",
        accessor: "type",
        filterable: true,
        Cell: cellProps => {
          return <Total {...cellProps} />
        },
      },
      {
        Header: "Imaging Test",
        accessor: "name",
        filterable: true,
        Cell: cellProps => {
          return <Total {...cellProps} />
        },
      },
      {
        Header: "Price",
        accessor: "pricing",
        filterable: true,
        Cell: cellProps => {
          return <Cost {...cellProps} />
        },
      },
      {
        Header: "Notes",
        accessor: "notes",
        filterable: true,
        Cell: cellProps => {
          return <Total {...cellProps} />
        },
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3 justify-content-end">
              <div>
                {cellProps.row.original.scansOrReports &&
                  cellProps.row.original.scansOrReports.length > 0 ? (
                  <Link
                    to={`#`}
                    className="text-success"
                    onClick={() => {
                      setCurrentScans(cellProps.row.original.scansOrReports)
                      setisGalleryZoom(true)
                      setphotoIndex(0)
                    }}
                  >
                    <i id={"viewScansTooltip" + cellProps.row.original._id}>
                      <IconSVG icon="more" />
                    </i>
                  </Link>
                ) : (
                  <span className="text-muted">
                    <i id={"noScansTooltip" + cellProps.row.original._id}>
                      <IconSVG icon="more" />
                    </i>
                  </span>
                )}

                {cellProps.row.original.scansOrReports &&
                  cellProps.row.original.scansOrReports.length > 0 ? (
                  <UncontrolledTooltip
                    placement="top"
                    target={"viewScansTooltip" + cellProps.row.original._id}
                  >
                    View Scans
                  </UncontrolledTooltip>
                ) : (
                  <UncontrolledTooltip placement="top" target={"noScansTooltip" + cellProps.row.original._id}>
                    No Scans Available
                  </UncontrolledTooltip>
                )}
              </div>
            </div>
          )
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Row className="mx-2 mb-4 ">
            <Col
              className="d-flex align-items-center justify-content-start gap-2"
              md={12}
            >
              <img
                src={LeftArrow}
                width={32}
                onClick={() => history.goBack()}
                role="button"
              />
              <h4 className="mb-0 font-fontFamily fontSize-28">
                Imaging Requests Completed
              </h4>
            </Col>

            <Col></Col>
          </Row>
          {/* <Breadcrumbs
            title="Dashboard"
            titleLink="/"
            breadcrumbItem="Imaging Requests Completed"
          /> */}
          {isGalleryZoom ? (
            <Lightbox
              mainSrc={currentScans[photoIndex]}
              nextSrc={currentScans[(photoIndex + 1) % currentScans.length]}
              prevSrc={
                currentScans[
                (photoIndex + currentScans.length - 1) % currentScans.length
                ]
              }
              onCloseRequest={() => {
                setisGalleryZoom(false)
              }}
              onMovePrevRequest={() => {
                setphotoIndex(
                  (photoIndex + currentScans.length - 1) % currentScans.length
                )
              }}
              onMoveNextRequest={() => {
                setphotoIndex((photoIndex + 1) % currentScans.length)
              }}
            />
          ) : null}
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={list}
                    isGlobalFilter={false}
                    isAddOptions={true}
                    handleOrderClicks={handleAddNewRequest}
                    customPageSize={10}
                    emptyListLink="/add-imaging-request"
                    emptyText="No requests found"
                    emptyLinkText="+ New Imaging Request"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}
ImagingRequestList.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default ImagingRequestList
